import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { MembersTypes } from "@/types";

export interface MemberSearchState {
  memberSearchOptions: MembersTypes.MemberSearchOptions;
  memberSearchResults: {
    results: Array<MembersTypes.MemberSearchResult>;
    result_count: string;
  };
}

const DEFAULT_MEMBER_SEARCH_STATE: MemberSearchState = {
  memberSearchOptions: {
    full_text_search: "",
    order_by: [],
    page_number: 1,
    results_per_page: 20,
  },
  memberSearchResults: {
    results: [],
    result_count: null,
  },
};

export default (state: MemberSearchState = DEFAULT_MEMBER_SEARCH_STATE, action: Action): MemberSearchState => {
  if (action.type === ActionTypes.SEARCH_FOR_MEMBER) {
    return {
      ...state,
      memberSearchOptions: action.payload,
    };
  } else if (action.type === ActionTypes.SEARCH_FOR_MEMBER_RESULTS) {
    return {
      ...state,
      memberSearchResults: action.payload,
    };
  }

  return state;
};
